module.exports = __webpack_public_path__ + "img/XT-ConsumiblesTipoTweco.929b7512.png";